import { GLOBAL } from '../../../../../config/routes/view-frontend.json';
import { getAccountDetails } from './domainInfo';

export default function uiPrefix(path: string) {
  const { siteName } = getAccountDetails();

  return `/${siteName}/${GLOBAL.APP_NAME}/${path}`;
}
